export default [
  {
    title: 'Название (А-Я)',
    field: 'title.asc',
    options: {
      by: 'title',
      order: 'asc'
    }
  },
  {
    title: 'Название (Я-А)',
    field: 'title.desc',
    options: {
      by: 'title',
      order: 'desc'
    }
  },
  {
    title: 'Cортировка по возрастанию',
    field: 'sort.asc',
    options: {
      by: 'sort',
      order: 'asc'
    }
  },
  {
    title: 'Cортировка по убыванию',
    field: 'sort.desc',
    options: {
      by: 'sort',
      order: 'desc'
    }
  },
  {
    title: 'Активность по возрастанию',
    field: 'activity.asc',
    options: {
      by: 'activity',
      order: 'asc'
    }
  },
  {
    title: 'Активность по убыванию',
    field: 'activity.desc',
    options: {
      by: 'activity',
      order: 'desc'
    }
  },
]